export default __webpack_public_path__ + "static/media/logo_holoray_black.579aee2c.png";